/*
 * @Author: liangen(80398513)
 * @Date: 2023-12-20 17:20:14
 * @Description:
 * @LastEditors: liangen(80398513)
 */
import axios from 'axios'
import {
  Message
} from '@gcommon/gcommon-ui'
import { getQueryString } from './utils'
// axios.defaults.baseURL = window.env.baseURL
axios.defaults.withCredentials = true

// axios.interceptors.request.use(config => {
//   config.headers.authorization = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI4MDMzNDU0MiIsImlzcyI6ImRhdGEtYXBwIiwiZXhwIjoxNjYzNzMxMTM4LCJpYXQiOjE2NjExMzkxMzh9.YZ5d6gBkxSDHiJPa1OQqoaZIHy2M6EmGXPK2RHFSW0U'
//   return config
// })

axios.interceptors.request.use(
  (config) => {
    const cem_token = getQueryString('cem_token')
    config.headers['cem_token'] = cem_token || ''
    return config
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (res) => {
    if (res.data instanceof Blob) {
      return res
    }
    if (res?.data?.code === 0 || res?.data?.code === 200) {
      return res.data
    }
    return res.data || res
  },
  (err) => {
    if (err.response.status === 401) {
      if (err.response.headers.location) {
        window.location.href = err.response.headers.location
      } else {
        window.location.reload()
      }
    }
    if ([500, 501, 502, 503, 429, 504].includes(err.response.status)) {
      const msg = err.msg || '服务错误'
      // window.location.href = `${window.location.origin}/v2/front/accessFailed`
      Message.closeAll()
        if (msg) {
        Message({
          message: msg,
          type: 'error',
          duration: 3 * 1000,
          showClose: true
        })
      }
    }
    // if([504].includes(err.response.status)){
    //   Message({
    //     message: '代理服务器尝试执行请求时，未能及时从上游服务器收到响应',
    //     type: 'error'
    //   })
    // }
    return Promise.reject(err.response)
  }
)
export default axios
